module.exports = __webpack_public_path__ + "static/media/bryllup_siste_bilde.14485982.JPG";